import type { ArtworkRecord, SearchHit } from '../../../../../packages/contracts/src/search.js';
import type { MapView } from '../../app/app.types.js';

export interface MapCoordinate {
  readonly x: number;
  readonly y: number;
}

export const QUERY_COORDINATE: MapCoordinate = { x: .5, y: .48 };

export function resultCoordinate(rank: number, count: number): MapCoordinate {
  const safeCount = Math.max(1, count);
  const angle = ((rank - 1) / safeCount) * Math.PI * 2 - Math.PI / 2;
  const alternating = rank % 2 === 0 ? 1 : .9;
  return {
    x: QUERY_COORDINATE.x + Math.cos(angle) * .205 * alternating,
    y: QUERY_COORDINATE.y + Math.sin(angle) * .225 * alternating
  };
}

export function buildDisplayCoordinates(
  items: readonly ArtworkRecord[],
  hits: readonly SearchHit[],
  view: MapView
): ReadonlyMap<string, MapCoordinate> {
  const hitRanks = new Map(hits.map((hit) => [hit.id, hit.rank]));
  const resultCount = Math.max(1, hits.length);
  return new Map(items.map((item) => {
    const rank = hitRanks.get(item.id);
    const coordinate = view === 'focus' && rank
      ? resultCoordinate(rank, resultCount)
      : { x: item.x, y: item.y };
    return [item.id, coordinate] as const;
  }));
}
